import * as React from 'react';
import {Route, Routes} from "react-router";
import Pay from 'Pay';
import DialogBox from 'DialogBox';

const RouterComponent = () => {
  return (
    <div className="container">
       <Routes>
        <Route index element={<Pay/>} />
        <Route path='/success' element={<DialogBox/>} />
      </Routes>
    </div>
  );
};

export default RouterComponent;